// src/components/auth/ServiceTermsDetail.tsx
import React from 'react';
import styles from '../../styles/auth/TermsDetail.module.css';
import backArrowIcon from '../../assets/image/backArrowIcon.svg';

interface ServiceTermsDetailProps {
  onBack: () => void;
  onClose: () => void;
  isChecked: boolean;
  onToggleCheck: () => void;
}

const ServiceTermsDetail: React.FC<ServiceTermsDetailProps> = ({
  onBack,
  onClose,
  isChecked,
  onToggleCheck,
}) => {
  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.container}>
        <div className={styles.header}>
          <button className={styles.backButton} onClick={onBack}>
            <img src={backArrowIcon} alt="back" />
          </button>
          <h1 className={styles.headerTitle}>서비스 이용약관</h1>
        </div>

        <div className={styles.content}>
          <h2 className={styles.mainTitle}>(필수) 찐빵 서비스 이용약관 동의</h2>
          <div className={styles.termsContent}>
            <pre className={styles.preformattedContent}>
              {`찐빵 웹서비스 이용약관 (안)
최초 시행 일자 : 2025 년  1 월 13 일

제 1 조 (목적)
본 약관은 유니브(이하 “회사”)가 웹사이트 “찐빵”(이하 “서비스”)를 통하여 제공하는 자취 정보 공유·검색 및 이에 부수하는 제반 서비스의 이용과 관련하여, 회사와 회원 간 권리·의무 및 책임, 기타 필요한 사항을 규정함을 목적으로 합니다.

제 2 조 (용어의 정의)
회원 : 본 약관에 동의하고 회사가 제공하는 서비스를 이용하는 자
서비스 : 실거주 후기·매물 정보·공인중개사 평가·법률 가이드 등 “찐빵” 웹사이트에서 제공하는 모든 기능
웹사이트 : 회사가 도메인 jjinbbang.co.kr 등으로 운영하는 인터넷 사이트
아이디(ID) : 회원 식별과 서비스 이용을 위하여 회원이 정하고 회사가 승인한 문자·숫자 또는 그 조합
비밀번호 : 회원 본인 확인과 권익 보호를 위하여 회원이 설정한 문자·숫자 또는 그 조합
본 조에서 정하지 않은 용어는 관계법령과 일반적 관례에 따릅니다.

제 3 조 (약관의 명시·효력·개정)
본 약관은 서비스 초기 화면 또는 연결 화면에 게시함으로써 효력이 발생합니다.
회사는 약관을 변경할 수 있으며, 변경 시 적용일자 최소 7 일 전 서비스 내 공지합니다. 이용자에게 불리한 변경은 30 일 전 공지 및 이메일·PNS 등 개별 통지합니다.
이용자가 변경 약관 적용일까지 거부 의사를 밝히지 아니한 경우 동의한 것으로 간주합니다.

제 4 조 (이용계약의 체결)
회원 가입 양식 작성 및 약관 동의 → “가입하기” 클릭 시 이용계약이 성립합니다.
회사는 설비 여력·보안·기술상 사유로 승낙을 유보하거나 거절할 수 있으며, 거절 사유는 화면에 공지합니다.
다음 각 호에 해당할 경우 승낙을 거절할 수 있습니다.
① 타인 명의 사용 ② 허위 정보 기재 ③ 법령 위반 목적 ④ 만 14 세 미만 등

제 5 조 (회원 정보 변경)
회원은 “내 정보” 페이지에서 언제든지 개인정보를 열람·수정할 수 있으며, 정보 변경 미통보로 발생한 불이익은 회사가 책임지지 않습니다.

제 6 조 (개별 정책)
서비스별 추가 약관·정책이 있을 경우 별도 동의 절차를 거치며, 상충 시 개별 약관이 우선합니다.

제 7 조 (개인정보 보호)
회사는 개인정보보호법 등 관계 법령에 따라 회원 정보를 보호하며, 상세 사항은 “개인정보처리방침”에 따릅니다.

제 8 조 (회사의 의무)
안정적인 서비스 제공과 보안 유지에 최선을 다합니다.
회원 의견·불만이 정당하다고 판단될 경우 처리 현황을 이메일·게시판 등을 통해 알립니다.

제 9 조 (회원의 의무)
회원은 다음 행위를 하여서는 안 됩니다.
타인 정보 도용, 서비스 장애 유발, 자동화 스크립트 사용
허위 후기 게재, 명예훼손·음란·사행 행위
회사·타인 지식재산권 침해, 영리 목적 무단 정보 수집 등

제 10 조 (회원 통지)
회사는 중요 공지를 서비스 내 배너·팝업·알림(PNS)으로 통지하며, 불특정 다수일 경우 7 일 이상 게시로 개별 통지에 갈음할 수 있습니다.

제 11 조 (서비스 범위)
회사가 제공하는 주요 기능
① 자취방·원룸 실거주 후기 열람 및 작성
② 공인중개사 정보·별점·리뷰
③ 표준임대차계약서·법률 가이드 및 상담 연결
기능·화면은 운영상 필요에 따라 변경·중단될 수 있습니다.

제 12 조 (서비스 중단)
서버 점검·천재지변 등 부득이한 사유 발생 시 회사는 서비스 제공을 일시 중단할 수 있으며, 사전에 사이트 공지 후 중단합니다(긴급 장애 시 사후 공지).

제 13 조 (광고·정보 제공)
회사는 서비스 화면·이메일·PNS를 통해 서비스 관련 정보·광고를 제공할 수 있으며, 회원은 수신 거부할 수 있습니다.

제 14 조 (서비스 변경·중단)
경영상 필요, 제휴 계약 종료, 수익 악화 등 사유로 서비스 전부 또는 일부를 중단할 수 있으며, 최소 30 일 전 공지합니다.

제 15 조 (지식재산권)
“찐빵” 웹사이트의 UI·데이터·콘텐츠 등의 저작권은 회사에 귀속합니다.
회원이 작성한 후기·게시물은 서비스 운영·홍보를 위해 저장·편집·2차 가공될 수 있습니다.

제 16 조 (약관 외 준칙)
본 약관과 개별 약관에 명시되지 않은 사항은 관계 법령 및 일반 관례에 따릅니다.

제 17 조 (제3자 링크)
서비스 내 외부 사이트·광고 링크는 편의를 위한 것이며, 외부 콘텐츠에 대한 신뢰성·안전성은 회사가 보증하지 않습니다.
제 18 조 (면책)
천재지변·불가항력·회원 귀책으로 인한 서비스 장애는 회사 책임이 면책됩니다.
회사는 무료로 제공하는 서비스 이용으로 발생한 손해에 대하여 책임을 지지 않습니다.
제 19 조 (관할법원)
서비스 이용과 관련하여 회사와 회원 사이에 분쟁이 발생할 경우, 대한민국 법을 준거법으로 하며, 창원지방법원 진주지원(회사 본사 소재지 관할)을 전속적 합의 관할로 합니다.
본 약관은 2025년 6월 13일부터 적용됩니다.`}
            </pre>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceTermsDetail;
